export function money(n: number | null | undefined): string {
  if (n === null || n === undefined) return ''
  return n.toLocaleString('en-US')
}

export function currentPeriod(): string {
  const d = new Date(Date.now() + 8 * 3600 * 1000)
  return d.toISOString().slice(0, 7)
}

export function today(): string {
  const d = new Date(Date.now() + 8 * 3600 * 1000)
  return d.toISOString().slice(0, 10)
}

/**
 * ISO 日期（YYYY-MM-DD）拆成民國年月日，給合約類文件的「中華民國　年　月　日」用。
 *
 * 資料庫存的 signed_on 一律來自 <input type="date">，固定是 ISO 西元格式，
 * 所以換算就是年減 1911，不需要猜格式。小於等於 1911 的年份視為「已經是民國年」
 * 原樣回傳，避免資料被人工改成民國年後又被減一次。
 *
 * 月、日回傳去掉前導零的字串（8 而不是 08），與範本原文的寫法一致。
 */
export function rocDate(iso: string | null | undefined): { y: string; m: string; d: string } {
  if (!iso) return { y: '', m: '', d: '' }
  const [y, m, d] = iso.split('-').map(Number)
  if (!y || !m || !d) return { y: '', m: '', d: '' }
  return { y: String(y > 1911 ? y - 1911 : y), m: String(m), d: String(d) }
}

/**
 * 由舊到新列出「含本月在內」的最近 N 個月。
 * 走勢圖用來把沒有發包的月份補成空格子，X 軸才會是連續的 12 格。
 */
export function recentPeriods(count = 12): string[] {
  const now = new Date(Date.now() + 8 * 3600 * 1000)
  const out: string[] = []
  for (let i = count - 1; i >= 0; i--) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1)
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`)
  }
  return out
}

/** 產生近 N 個月的 YYYY-MM 清單（含未來 1 個月） */
export function periodOptions(count = 18): string[] {
  const out: string[] = []
  const now = new Date(Date.now() + 8 * 3600 * 1000)
  for (let i = -1; i < count; i++) {
    const d = new Date(now.getFullYear(), now.getMonth() - i, 1)
    out.push(`${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`)
  }
  return out
}

export const STATUS_TONE: Record<string, string> = {
  待補充: '', // 草稿還沒送出，刻意留中性灰，不要跟需要動作的狀態搶眼
  待審核: 'warn',
  草稿: '',
  已核准: 'ok',
  已生效: 'ok',
  已終止: '',
  待確認: 'warn',
  待交稿: 'info',
  已交稿: 'info',
  驗收中: 'warn',
  已完成: 'ok',
  終止: 'bad',
  待請款: 'warn',
  已請款: 'ok',
  驗收通過: 'ok',
  有條件通過: 'warn',
  退修: 'bad',
  驗收不通過: 'bad',
}
